// extracted by mini-css-extract-plugin
export var root = "RaceResultDistance-module--root--1QCGB";
export var place = "RaceResultDistance-module--place--3n1iF";
export var place1 = "RaceResultDistance-module--place1--3arUu";
export var place2 = "RaceResultDistance-module--place2--24eFa";
export var place3 = "RaceResultDistance-module--place3--WwLDT";